export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10206.8c62bdd0.jpg";